import React from "react";
import Layout from "../components/Layout/Layout";
import { NavLink } from "react-router-dom";
import axios from "axios";
function About() {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);
  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}AboutUs.aspx`)
      .then((res) => {
        setData(res.data[0]);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <Layout loading={loading} title="درباره ما">
      {/* <!-- Breadcumbs start --> */}
      <div class="e-breadcumb-wrap text-center">
        <h2 class="e-breadcumb-title">درباره ما</h2>
        <ul class="e-breadcumb-kist">
          <li>
            <NavLink to="/">خانه </NavLink>
          </li>
          <li>
            <NavLink to="/about">درباره ما</NavLink>
          </li>
        </ul>
      </div>
      {/* <!-- شرایط و ضوابط start --> */}
      {data && (
        <div class="e-privacy-wrap">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="e-privacy-sec">
                  <div class="e-privacy-box mb-30">
                    <h2 class="cmn-brdr-ttle big-ttl mb-10">
                      شرکت رادین صنعت رایان
                    </h2>
                    <p style={{ marginTop: "2em", lineHeight: "30px" }}>
                      {data.description}
                    </p>
                    <br />
                    <br />
                    <b><h5>مأموریت</h5> </b> 
                    <p style={{lineHeight: "30px" }}>
                    شرکت رادین صنعت رایان با اتکاء بر دانش تخصصی، فناوری نوین و
                    سرمایه انسانی متعهد، مأموریت خود را در زمینه طراحی، تولید و
                    تأمین واکسن‌های دام، طیور و آبزیان با کیفیت ممتاز و منطبق با
                    بالاترین استانداردهای بین‌المللی تعریف می‌نماید. هدف ما
                    ارتقای سطح سلامت دام و طیور کشور، کاهش وابستگی به واردات،
                    بهینه‌سازی هزینه‌ها و تأمین پایدار محصولات سلامت‌محور در
                    مقیاسی ملی و منطقه‌ای است. در راستای تحقق این مأموریت، این
                    شرکت با توسعه سبد محصولات واکسن ، مواد بیولوژیک و
                    ضدعفونی‌کننده تخصصی، نقش مؤثری در پیشگیری از بیماری‌ها،
                    ارتقای بهداشت زیستی و حفظ بهره‌وری در صنعت دامپروری ایفا
                    می‌نماید. محصولات ما حاصل تلفیق فناوری پیشرفته، فرمولاسیون
                    علمی و فرآیندهای کنترل کیفیت دقیق می‌باشند که مطابق با
                    الزامات مراجع معتبر بین‌المللی طراحی و عرضه می‌گردند. اصول
                    بنیادین فعالیت‌های ما، بر پایه اخلاق حرفه‌ای، کیفیت ماندگار
                    ، دقت در اجرا، سرعت در پاسخگویی و تعهد به توسعه پایدار بنا
                    نهاده شده است. ما بر این باوریم که با نوآوری مستمر، رویکرد
                    علمی و مسئولیت‌پذیری اجتماعی، می‌توانیم نقشی ماندگار در صنعت دامپزشکی ایفا نماییم.</p>
                    <br /> 
                    <br/>
                    <br/>
                    <p>
                      <b>بخش مدیریت</b> <br />
                      رئیس هیات مدیره: دکتر نادر وجدانی فر <br />
                      مدیرعامل : مهندس فرزاد نصری
                      <br />
                      <br />
                      <b>بخش علمی فنی </b> <br />
                      معاون فنی : دکتر سید علی غفوری <br />
                      مدیر تحقیق و توسعه: دکتر مهرداد مدیر صانعی <br />
                      مدیر علمی فنی محصولات دامی : دکتر داراب عبدالهی <br />
                      مدیر علمی- فنی بخش دام بزرگ: دکتر حسین خالصی <br />
                      مدیر علمی - فنی بخش طیور: دکتر محمدهادی کیانی <br />
                      <br />
                      <b>بخش بازرگانی </b> <br />
                      معاون بازرگانی: دکتر مهرداد شیرین آبادی <br />
                      {/* مدیر بازرگانی خارجی: دکتر کامبیز نباتی <br /> */}
                      <br />
                      <b>بخش فروش </b> <br />
                      مدیر فروش محصولات طیوری : دکتر سید مسعود شیخ الاسلام
                      <br />
                      مدیر فروش واکسن های باکتریایی و ویروسی دام : دکتر میثم
                      کریمی
                      <br />
                      مدیر فروش واکسن های حیوانات همراه : دکتر رضا رستم نیا
                      <br />
                      <br />

                      <b>دپارتمان فید</b><br/>
                      رئیس دپارتمان فید : مهندس بهمن صفایی
                      <br />

                      <br />
                      <b>بخش مالی و حسابداری </b> <br />
                      مدیر مالی : دکتر علی بخشی
                      <br />
                      رئیس بخش خزانه داری : آقای فرزاد بهاروند
                      <br />
                      کارشناس بخش حسابداری: خانم سمیه رحیمی
                      <br />
                      کارشناس بخش حسابداری : خانم مونا عراقی
                      <br />
                      کارشناس بخش حسابداری : خانم ریحانه بازقندی
                      <br />
                      <br />
                      <b>
                        بخش <span className="h5">CRM :</span>
                      </b>{" "}
                      <br />
                      دکتر عطا اله دادگر
                      <br />
                      <br />
                      <b>شعبات :</b> <br />
                      مدیر شعبه مازندران : خانم سارا صادقی
                      <br />
                      مدیر شعبه گلستان : خانم ناهید وجدانی فر
                      <br />
                      مدیر شعبه شیراز : خانم دکتر سارا منجزی
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default About;
